export const SPACE = '\u0020';

export const NON_BREAKING_SPACE = '\u00A0';
